/*jshint esversion: 6 */
export function deletePargraphFromPageParagraphArray(paragrId, allpages, pageUtils){
    console.log(" deletePargraphFromPageParagraphArray paragrId", paragrId);
    //var allpages = this.state.pages.slice();
    console.log(" deletePargraphFromPageParagraphArray allpages", allpages);
    allpages.map(page => {
        let pageParagrArr = page.paragraphs.slice();
        if(pageParagrArr.includes(paragrId)){
            let indexOfParagr = pageParagrArr.indexOf(paragrId);
            pageParagrArr.splice(indexOfParagr, 1);
            page.paragraphs = pageParagrArr;
            console.log(" deletePargraphFromPageParagraphArray page", page);
            pageUtils.putPage(page, page._id);
        }
    })
}


export function checkIfAtLeastOneCheckBoxIsChecked(){
    var chk_arr =  document.getElementsByName("paragraphHasPage[]");
    var atLeastOneIsChecked = false;
    var i;
    //console.log("CHECKBOX c" , chk_arr);
    for (i = 0; i < chk_arr.length; i++) {
        //console.log("CHECKBOX" , chk_arr[i]);
        if(chk_arr[i].checked){
            atLeastOneIsChecked = true;
            break;
        }
    }
    return atLeastOneIsChecked;
}

export function mapIdToName(paragId, paragArr){
    let parObj = paragArr.filter(paragItem => paragItem._id === paragId);
     if(parObj){
         if(parObj[0]){
             return parObj[0].header;
         }
     }
 }
 
export function getPageParagrphObjects(pageObject, allParagraphsArr){
    var pageParagraphs = pageObject.paragraphs;
    var pageId = pageObject._id;
    var pageParagraphObjects  = [];
    if(pageParagraphs){
        if(pageParagraphs.length > 0){
            //console.log("PARG LENGTH", pageParagraphs.length);
            //pargraphs, that include the same page id in '.pages' list
            pageParagraphObjects = allParagraphsArr.filter(paragObj => pageParagraphs.includes(paragObj._id));
        }
    }
    return pageParagraphObjects;
}

export function sanitazePageOrderPair(page, pragraphsList, self){
    //console.log('page- sanitazePageOrderPair', page);
    if(page.largestOrder){
        let pageParagraphs = page.paragraphs;
        //procees paragrah order pair is present
        pageParagraphs.map(paragrId => {
            let pageParagraphArr = pragraphsList.slice().filter(p => p._id === paragrId);
            if(pageParagraphArr){
                if(pageParagraphArr.length){
                    let pageParagraph = pageParagraphArr[0];
                    if(pageParagraph){
                        let paragrffOrders = pageParagraph.orders;
                        let orderValue = getOrderValuFromArr(paragrffOrders, page._id);
                        //sanitaze order value
                        if(orderValue < 1){
                            self.addPageOrderPair(pageParagraph, page._id, (page.largestOrder+1) );
                        }
                    }
                }
            }
        })
    }
}

export function getLargestPargrphOrderByPage(pageObject, allParagraphsArr){
    var maxOrderNumber = 0;
    var pageParagraphObjects = getPageParagrphObjects(pageObject, allParagraphsArr);
    //console.log('getLargestPargrphOrderByPage pageParagraphObjects', pageParagraphObjects)
    if(pageParagraphObjects){
        if(pageParagraphObjects.length){
            pageParagraphObjects.map(paragr => {
                //console.log('getLargestPargrphOrderByPage paragr', paragr)
                var pOrdersArray = paragr.orders;
                pOrdersArray.map(orderPair =>{
                    //console.log('getLargestPargrphOrderByPage orderPair', orderPair)
                    var orderNumericValue = getOrderValuFromPair(orderPair);
                    //console.log('getLargestPargrphOrderByPage orderNumericValue', orderNumericValue)
                    if(orderNumericValue > maxOrderNumber){
                        maxOrderNumber = orderNumericValue;
                    }
                })
            })
        }
    }
    return maxOrderNumber;
}

export function getPagelessParagraphs(allpages, allparagraphs){
    var paragraphsIdsThatHaveParentPage = [];
    let pagelessParagraphs = [];
    allpages.map(page  => {                               
        let pageParagraphs = page.paragraphs.slice();
        if(pageParagraphs){
            if(pageParagraphs.length){
                //add pageparagraphs to general arr for later evaluate
                //paragraphs, that dont have parent page
                pageParagraphs.map(paragID => {
                    if(!paragraphsIdsThatHaveParentPage.includes(paragID)){
                        paragraphsIdsThatHaveParentPage.push(paragID);
                    }
                })
            }
        }
    });
    //get pageless paragraphs
    if(!paragraphsIdsThatHaveParentPage.length){
        pagelessParagraphs = allparagraphs;
    }else{
        allparagraphs.map(allParagObj => {
            if(!paragraphsIdsThatHaveParentPage.includes(allParagObj._id)){
                pagelessParagraphs.push(allParagObj);
            }
        })
    }
    return pagelessParagraphs;
}



export function orderPargrphsByPage(pageObject, allParagraphsArr){
     var pageParagraphs = pageObject.paragraphs;
     var pageId = pageObject._id;
     var ordered = [];
     var pageParagraphObjects = getPageParagrphObjects(pageObject, allParagraphsArr);
     if(pageParagraphObjects){
        if(pageParagraphObjects.length){
            //order paragraphs by their order in that page
            if(pageParagraphObjects.length === 1){
                ordered = pageParagraphObjects;
            }
            else{
                ordered = pageParagraphObjects.sort(function(a,b){
                    //find order, that contains page id
                    var a_order = a.orders.filter(aOrd => aOrd.indexOf(pageId) > -1);
                    var b_order = b.orders.filter(bOrd => bOrd.indexOf(pageId) > -1);
                    var a_order_value = null;
                    var b_order_value = null;
                    if(a_order){
                        if(a_order[0]){
                            a_order_value = getOrderValuFromPair(a_order[0]);
                        }
                    }
                    if(b_order){
                        if(b_order[0]){
                            b_order_value = getOrderValuFromPair(b_order[0]);
                        }
                    }
                    //console.log("Aorder", a_order_value);
                    //console.log("Border", b_order_value);
                    if(a_order_value && b_order_value){
                        return (a_order_value - b_order_value);
                    }

                });
            }
        }
    } 

    // if(ordered){
    //     console.log('ORDERED PArAGRAPHS', ordered);
    // }
    
    return ordered;
 }


 export function getOrderValuFromPair(orderPair) {
    let pairArray = orderPair.split(':');
    let numericOrder = null;
    if(pairArray.length === 2){
        numericOrder = parseInt(pairArray[1]);
    }
    return numericOrder;
  }

  export function getOrderValuFromArr(paragrffOrders, pageId){
    let numericOrder = 0;
    if(paragrffOrders){
        if(paragrffOrders.length){
            paragrffOrders.filter(pgrffOrderPair => (pgrffOrderPair.indexOf(pageId) > -1) );
            if(paragrffOrders){
                if(paragrffOrders[0]){
                    numericOrder = getOrderValuFromPair(paragrffOrders[0]);
                }
            }
        }
    }
    
    return numericOrder;
  }


// WEBPACK FOOTER //
// ./src/utils/PageParagraphFuncs.js